const RemotePositionsEnum = Object.freeze({
  Čeština: 'Zobrazit pouze pozice na dálku',
  Deutsch: 'Nur Remote-Stellen anzeigen',
  Français: "Offres d'emplois à distance uniquement",
  Slovenčina: 'Zobraziť len pozície na diaľku',
  Español: 'Sólo mostrar puestos remotos',
  English: 'Only Show Remote Positions',
})

export default RemotePositionsEnum
